<template>
  <div class="dataList">
    <ul class="">
      <li v-for="(item,index) in dataList" :key="index">
        <p class="p-order">
          订单号：{{item.orderNum}}
          <span>丨</span>
          <span class="s-time">{{item.time}}</span>
        </p>
        <div class="order-details">
          <div class="d-details">
            <div class="d-img">
              <img :src="item.imgUrl" alt="">
            </div>
            <div class="d-name">
              {{item.name}}
            </div>
            <div class="d-money">
              <strong>
                ￥{{item.money}}
              </strong>
              <!-- <span>X{{item.num}}</span> -->
            </div>
            <div class="d-author">
              {{item.bookType === 0 ? '纸质书' : '电子书'}}
            </div>
          </div>
          <div class="d-state">
            {{item.stateText}}
          </div>
          <div class="d-operation">
            <button v-show="item.state === 0" @click="operation(item, 'pay')" class="payment" type="">支付</button>
            <button @click="operation(item, 'details')">订单详情</button>
            <button v-show="item.state === 0" @click="operation(item, 'cancel')">取消</button>
            <button v-show="item.state === 3" @click="operation(item, 'track')">跟踪</button>
            <button v-show="item.state === 3" @click="operation(item, 'qr')">确认收货</button>
          </div>
        </div>
      </li>
    </ul>
    <div class="pagination">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage3"
        :page-size="pages.size"
        layout="prev, pager, next, jumper"
        :total="pages.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    dataList: {
      type: Array,
      default: null
    },
    pages: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      currentPage3: 5
    }
  },
  methods: {
    operation (row, type) {
      this.$emit('operation', {
        type: type,
        row: row
      })
    },
    handleCurrentChange (val) {
      this.$emit('handleCurrentChange', val)
    }
  }
}
</script>
<style lang="less" scoped>
  .dataList{
    .pagination{
      text-align: right;
      padding: 50px 0;
    }
    ul{
      list-style: none;
      margin: 0;
      padding: 0;
      font-size: 14px;
      li{
        .p-order{
          background-color: #F5F5F5;
          line-height: 30px;
          padding: 0 10px;
          margin: 0;
          .s-time{
            color: #A8A8A8;
          }
        }
        .order-details{
          border: 1px solid #DEDEDE;
          display: flex;
          padding: 25px 0;
          .d-details{
            flex: 1;
            display: flex;
            .d-img{
              padding-left: 20px;
              img{
                width: 65px;
              }
            }
            .d-name{
              padding: 0 20px;
              flex: 1;
            }
            .d-money{
              strong{
                font-size: 16px;
                color: #b60e0e;
              }
              span{
                font-size: 14px;
                color: #A8A8A8;
              }
            }
            .d-author{
              width: 200px;
              text-align: right;
            }
          }
          .d-state{
            width: 300px;
            text-align: center;
          }
          .d-operation{
            width: 80px;
            padding: 0 20px;
            text-align: center;
            button{
              border: 0;
              padding: 3px 10px;
              background-color: white;
              outline: none;
              cursor: pointer;
            }
            .payment{
              background-color: #b60e0e;
              color: white;
              padding: 3px 20px;
              margin-bottom: 5px;
            }
          }
        }
      }
    }
  }
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #B7151E !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/MyOrder/list.vue


// WEBPACK FOOTER //
// src/components/Personal/MyOrder/list.vue